import { render } from "./Conversation.vue?vue&type=template&id=807e42ce"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"

import "./Conversation.vue?vue&type=style&index=0&id=807e42ce&lang=css"
script.render = render

export default script